import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-de',
  templateUrl: './de.component.html',
  styleUrls: ['./de.component.scss']
})
export class DeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
